import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Navbar";

const FOOTER_NAV = [
  { label: "About", href: "/#about", id: "about" },
  { label: "What We Do", href: "/#what-we-do", id: "what-we-do" },
  { label: "Property Owners", href: "/#owners", id: "owners" },
  { label: "Development", href: "/#development", id: "development" },
  { label: "FAQ", href: "/#faq", id: "faq" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#111513]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-28 pb-12">
        <div className="max-w-3xl">
          <p className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F4F1EA] leading-[1.12]">
            Every property has a story.
            <br />
            <span className="italic text-[#A77A50]">Let&rsquo;s understand yours.</span>
          </p>
          <a
            href="/#contact"
            data-testid="footer-cta-link"
            className="group mt-9 inline-flex items-center gap-2 text-[13px] font-semibold tracking-[0.16em] uppercase text-[#A77A50] hover:text-[#C99A6C] transition-colors"
          >
            Start a Conversation
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
          </a>
        </div>
        <div className="mt-16 sm:mt-20 pt-12 border-t border-white/10 grid md:grid-cols-3 gap-10">
          <div>
            <a href="/" data-testid="footer-brand-wordmark" aria-label="Choose Me Properties — home">
              <Wordmark light />
            </a>
            <p className="mt-6 max-w-xs text-sm text-[#9AA49C] leading-relaxed">
              Real estate acquisition, property research, and land opportunities across Washington State.
            </p>
          </div>
          <div className="space-y-3.5">
            <a
              href="mailto:contact@choosemeproperties.com"
              data-testid="footer-email-link"
              className="flex items-center gap-3 text-sm text-[#D9D6CE] hover:text-[#A77A50] transition-colors break-all"
            >
              <Mail className="w-4 h-4 text-[#A77A50] shrink-0" aria-hidden="true" />
              contact@choosemeproperties.com
            </a>
            <a
              href="tel:+12064831705"
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-sm text-[#D9D6CE] hover:text-[#A77A50] transition-colors"
            >
              <Phone className="w-4 h-4 text-[#A77A50] shrink-0" aria-hidden="true" />
              (206) 483-1705
            </a>
            <p className="text-sm text-[#9AA49C]">
              Ask for Jeremy Alfred, Taj Alfred, or Robert Swearengen III.
            </p>
          </div>
          <nav className="space-y-3" aria-label="Footer">
            {FOOTER_NAV.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`footer-nav-${l.id}`}
                className="block text-sm text-[#D9D6CE] hover:text-[#A77A50] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-[#718477]">
            © {new Date().getFullYear()} Choose Me Properties LLC. All rights reserved.
          </p>
          <nav className="flex items-center gap-5" aria-label="Legal">
            <a href="/privacy" data-testid="footer-privacy-link" className="text-xs text-[#9AA49C] hover:text-[#A77A50] transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" data-testid="footer-terms-link" className="text-xs text-[#9AA49C] hover:text-[#A77A50] transition-colors">
              Terms of Use
            </a>
          </nav>
          <p className="text-xs text-[#718477]">
            Starting a conversation creates no obligation to sell.
          </p>
        </div>
      </div>
    </footer>
  );
};
